<template>
  <div>
    <div id="printMe">
      <van-row type="flex">
      <van-col span="24" class="title" v-if="flow.catalog">可恩口腔 - {{flow.catalog.title}}</van-col>
      </van-row>
      <van-row type="flex">  
      <van-col span="4">审批编号</van-col>
      <van-col span="8">{{flow.no}}</van-col>
      <van-col span="4">提交时间</van-col>
      <van-col span="8">{{flow.created_at}}</van-col>
      </van-row>
      <van-row type="flex">  
      <van-col span="4">申请人</van-col>
      <van-col span="8">{{flow.name}}</van-col>
      <van-col span="4">申请部门</van-col>
      <van-col span="8">{{flow.department}}</van-col>
      </van-row>
      <van-row type="flex">  
      <van-col span="4">当前审批状态</van-col>
      <van-col span="20" v-if="flow.status == 0">待审核</van-col>
      <van-col span="20" v-if="flow.status == 1">已通过</van-col>
      <van-col span="20" v-if="flow.status == 2">已驳回</van-col>
      <van-col span="20" v-if="flow.status == 5">已撤销</van-col>
      </van-row>
      <van-row type="flex">  

      <van-col span="24" class="sub_title">申请内容</van-col>
      </van-row>
      <van-row type="flex">  
      <van-col span="4">费用类型</van-col>
      <van-col span="20"  v-if="flow.catalog">{{flow.catalog.title}}</van-col>
      </van-row>
      <van-row type="flex">  
      <van-col span="4">申请内容</van-col>
      <van-col span="20">{{flow.title}}</van-col>
      </van-row>
      <van-row type="flex">  
      <van-col span="4">费用金额</van-col>
      <van-col span="20">{{flow.amount}}元（{{flow.amount_word}}）</van-col>
      </van-row>
      <van-row type="flex">  
      <van-col span="4">费用说明</van-col>
      <van-col span="20">{{flow.desc}}</van-col>
      </van-row>
      <van-row type="flex">  
      

      <van-col span="24" class="sub_title">付款信息</van-col>
      </van-row>
      <van-row type="flex"> 

      <van-col span="4">付款单位</van-col>
      <van-col span="20">{{flow.payer}} &nbsp;</van-col>
      </van-row>
      <van-row type="flex"> 

      <van-col span="4">收款户名</van-col>
      <van-col span="20">{{flow.payee}} &nbsp;</van-col>
      </van-row>
      <van-row type="flex"> 

      <van-col span="4">开户银行</van-col>
      <van-col span="20">{{flow.bank}} &nbsp;</van-col>
      </van-row>
      <van-row type="flex"> 

      <van-col span="4">银行账号</van-col>
      <van-col span="20">{{flow.bank_account}} &nbsp;</van-col>
      </van-row>
      <van-row type="flex"> 

      <van-col span="4">付款方式</van-col>
      <van-col span="20">{{flow.payment_term}} &nbsp;</van-col>
      </van-row>
      <van-row type="flex"> 


      <van-col span="24" class="sub_title">成本中心</van-col>
      </van-row>
      <van-row type="flex"> 
      <!-- <van-col span="8" class="text-center">成本中心</van-col> -->
      <van-col span="12" class="text-center">费用科目</van-col>
      <van-col span="12" class="text-center">分摊金额</van-col>
      </van-row>
      <van-row v-for="cost in flow.costs" :key="cost.id"  type="flex">
        <!-- <van-col span="8" class="text-center">{{cost.cost_center}}</van-col> -->
        <van-col span="12" class="text-center">{{cost.cost_account}}</van-col>
        <van-col span="12" class="text-center">{{cost.amount}}元</van-col>
      </van-row>
      <van-row type="flex"> 

      <van-col span="24" class="sub_title">审批流程 - 
        <span v-if="flow.status == 0">待审核</span>
        <span v-if="flow.status == 1">已通过</span>
        <span v-if="flow.status == 2">已驳回</span>
        <span v-if="flow.status == 5">已撤销</span>
      </van-col>
      </van-row>
      <van-row>
      <van-col span="12" class="text-center">审批人</van-col>
      <van-col span="12" class="text-center">操作记录</van-col>
      </van-row>
      <div v-for="(approvers,index) in flow.apprvoers" :key="index">
        <van-row v-for="approver in approvers"  :key="approver.id"  type="flex">
          <van-col span="12" class="text-center">{{approver.name}} - {{approver.position}}</van-col>
          <van-col span="12" class="text-center">
            <span v-if="approver.status == 0"><van-icon name="clock-o" />待审核</span>
            <span v-if="approver.status == 1"><van-icon name="passed" />已通过</span>
            <span v-if="approver.status == 2"><van-icon name="close" />已驳回</span>
            
            {{approver.approval_at}}</van-col>
          
        </van-row>
        
      </div>
      
      
    

    </div>
    <van-row class='bottom' type="flex" justify="center">
      
      <van-col span="6">
        <van-button v-print="printObj" type="primary"><van-icon name="passed" />打印</van-button>
      </van-col>
      
    </van-row>
    <Footer></Footer>
    
  </div>
</template>

<script>
import Footer from "../Footer.vue";
export default {
  
  name: 'Print',
  components: {
    Footer,
  },
  props: {
    
  },
  data(){
    return{
      flow:{},
      flow_id:this.$route.params.id,
      printObj: {
        id: 'printMe',
        popTitle: '',
        extraCss: '',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      }
    }
  },
  created(){
    // this.getCode();
    this.getdetail()

  },
  methods:{
    getdetail(){
      this.$http.get('/flow/'+this.flow_id)
      .then((res)=>{
        if(res.data.code == 204){
          this.$router.push({'name':'Login'})
          return false;

        }
        if(res.data.code != 200){
          console.log(res.data.msg)
        }
        // if(res.data.data.role == 0){
        //   this.$dialog.alert({
        //     message: '你没有权限查看此审批',
        //   }).then(() => {
        //     this.$router.push({
        //     name: 'Home',
        //     })
        //   });
        // }
        this.flow = res.data.data;
        this.printObj.popTitle = res.data.data.title

        // console.log(this.flow)
      })
      
    },

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.bottom{
  margin-bottom:140px;
  margin-top:20px;
}
.footer_bottom{
  position:fixed;
  bottom:30px;
  width:100%;
  height:60px; 
  z-index:99; 
  
}
.van-row{
  border-collapse:collapse;
}
.van-col{
  margin:0px -1px -1px 0px;
  border:solid #000 1px;
  padding:4px 10px;
  line-height:20px;
  text-align:left;
}
#printMe{
  font-size:10px;
}
#printMe .title{
  border:none;
  font-weight:bold;
  font-size:20px;
  margin:20px auto;
  text-align:center;
}
#printMe .van-icon{
  margin:5px;
}
.sub_title{
  text-align:center;
  font-weight:bold;
  font-size:16px;
}
.text-center{
  text-align:center;
}
</style>
